import React from 'react';
import {useDispatch} from "react-redux";
import {openModal} from "@/Store/Slices/ModalSlice";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";

const MultipleUnpublishCoupon =  ({checked}) => {
  const dispatch = useDispatch();

  const handleMultipleAction = () => {
    dispatch(openModal({
      modalType: 'multiple-coupon-modal',
      modalProps: {
        ids: checked,
        url: 'added.coupons.multi.unpublish',
        text: 'Do you want to unpublish selected coupons?',
      }
    }));
  }

  return (
    <button onClick={handleMultipleAction} className={'mr-3'} data-tip="Multiple unpublish coupons" >
      <FontAwesomeIcon
        rotation={180}
        color={'red'}
        size={'lg'}
        icon={solid('arrow-right-long')}/>
    </button>
  );
};

export default MultipleUnpublishCoupon;
